import React from 'react';

import Image from "next/legacy/image";
import QRCodeImage from './QR-v2.png';

import styles from './QRCode.module.scss';

export default function QRCode() {
  return (
    <div>
      <p className={styles.copy}>Scan to get the ChowNow app.</p>
      <Image
        src={QRCodeImage}
        alt="Chownow QR Code"
        className={styles.image}
        width={96}
        height={96}
      />
    </div>
  );
}
